var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('Header'),_c('div',{staticClass:"content-container"},[_c('MyBooking')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }